module.exports = __webpack_public_path__ + "static/img/bcg.bc3e4d2c.jpg";